(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hidden-in-plain-sight"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cg-hidden-game')) {
    customElements.define('cg-hidden-game', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.querySelector('.cg-hps__levels').hidden = false;
        this.querySelectorAll('[data-reveal]').forEach(button => { button.hidden = false; });
        this.selectLevel('easy');
        this.addEventListener('click', event => {
          const level = event.target.closest('[data-level]');
          const reveal = event.target.closest('[data-reveal]');
          if (level && this.contains(level)) this.selectLevel(level.dataset.level);
          if (reveal && this.contains(reveal) && !reveal.disabled) {
            this.setReveal(reveal.closest('[data-panel]'), reveal.getAttribute('aria-pressed') !== 'true');
          }
        });
      }
      setReveal(panel, revealed) {
        const button = panel.querySelector('[data-reveal]');
        const status = panel.querySelector('[data-status]');
        panel.querySelector('[data-before]').hidden = revealed;
        panel.querySelector('[data-after]').hidden = !revealed;
        button.setAttribute('aria-pressed', String(revealed));
        button.textContent = revealed ? button.dataset.hideLabel : button.dataset.showLabel;
        status.textContent = revealed ? status.dataset.revealedText : status.dataset.hiddenText;
      }
      selectLevel(level) {
        this.querySelectorAll('[data-panel]').forEach(panel => {
          panel.hidden = panel.dataset.panel !== level;
          this.setReveal(panel, false);
        });
        this.querySelectorAll('[data-level]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.level === level));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
